module.exports = [{"name":"AddMortgage","label":"Add Mortgage","on_click":"/rules/AddNewMortgage/QTE_PRP_MTG__Mtg","action":"POST"},{"name":"Mortgage Two","label":"Mortgage Two","on_click":"/rules/RemoveMortgage/QTE_PRP_MTG_1_Mtg","action":"POST"},{"name":"Mortgage Three","label":"Mortgage Three","on_click":"/rules/RemoveMortgage/QTE_PRP_MTG_2_Mtg","action":"POST"}]


//////////////////
// WEBPACK FOOTER
// ./config/admin/newButtons.json
// module id = nlx8
// module chunks = 2